import { SampleData } from "../../stores/Sample";
import { AlignmentOptions } from "../../stores/Search";
import { FeatureAnchor, SampleAnchor, SampleQuote } from "../PaperShared/Sample";
import { SamplesList } from "../SamplesList";

function Sample1079869() {
  const samplesList: SampleData[] = notableSamples.map(
    (sample) =>
      new SampleData(
        sample.text,
        [...sample.text],
        sample.activations,
        sample.normalizedActivation,
        sample.targetIdx,
        sample.absoluteTokenIdx,
        sample.modelId
      )
  );

  return (
    <>
      <h4>
        <SampleAnchor modelId="baby-v1" sampleId="1079869" />
        <span> - </span>
        <SampleQuote text="word for word" targetIdx={11} />
      </h4>
      <p>
        The letter “o” triggers activations three features. Feature{" "}
        <FeatureAnchor modelId="baby-v1" sampleId="1079869" featureKey="1.0.3237" compact /> fires
        exclusively on “o”s. Feature{" "}
        <FeatureAnchor modelId="baby-v1" sampleId="1079869" featureKey="1.0.334" compact /> fires
        most strongly on “e”s but also fires with half strength on “o”s. Feature{" "}
        <FeatureAnchor modelId="baby-v1" sampleId="1079869" featureKey="1.0.5421" compact /> fires
        most strongly on “a”s but also fires with half strength on “o”s. All three features are
        usually present within circuits that require processing of the letter “o”; however, some
        features are occasionally missing from specific token positions.
      </p>
      <p>
        In this sample circuit, feature{" "}
        <FeatureAnchor modelId="baby-v1" sampleId="1079869" featureKey="1.0.3237" compact /> is
        missing from the embedding layer representing the “o” in “for”. Downstream features may be
        searching for any vowel in this particular token position and may not specifically be
        seeking the letter “o”.
      </p>
      <figure>
        <figcaption>
          Activations for{" "}
          <FeatureAnchor modelId="baby-v1" sampleId="1079869" featureKey="1.0.334" /> +{" "}
          <FeatureAnchor modelId="baby-v1" sampleId="1079869" featureKey="1.0.5421" />
        </figcaption>
        <SamplesList
          samples={samplesList}
          alignment={AlignmentOptions.Left}
          rightPadding={20}
          hideActivation={true}
          showIcon={true}
        />
      </figure>
    </>
  );
}

const notableSamples = [
  {
    text: "? it is not yet near day:\nIt was the nightingale, and not the lark,\nThat pierced the fearful hollow of thine ear;\nNightly she sings on yon pomegranate-tree:\nBelieve me, love, it was the nightingale.\n\nROMEO:\nIt was the lark, the herald of the morn,\nNo night",
    activations: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0.481, 0, 0, 0, 0.517, 0, 0, 0, 0.523, 0.442, 0, 0, 0, 0.439, 0, 0,
      0, 0, 0, 0, 0, 0.45, 0, 0, 0, 0, 0.524, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.442, 0, 0.52, 0, 0,
      0.455, 0, 0, 0, 0, 0.499, 0, 0, 0, 0, 0.519, 0, 0, 0.449, 0, 0, 0, 0, 0, 0, 0.438, 0, 0, 0, 0,
      0.525, 0, 0, 0.526, 0, 0, 0, 0, 0.509, 0, 0, 0.524, 0.437, 0, 0, 0, 0, 0, 0, 0.499, 0, 0,
      0.508, 0, 0, 0.48, 0, 0, 0, 0, 0, 0, 0.514, 0, 0.506, 0.44, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0.523, 0, 0, 0, 0, 0, 0, 0, 0.515, 0, 0, 0, 0.486, 0, 0, 0, 0.484, 0, 0.521, 0, 0,
      0.441, 0, 0.433, 0, 0.513, 0, 0, 0, 0.516, 0.515, 0, 0, 0, 0.517, 0, 0, 0.518, 0, 0.519, 0, 0,
      0.527, 0, 0, 0, 0.518, 0, 0.523, 0, 0, 0, 0, 0, 0, 0.453, 0, 0, 0, 0, 0.538, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0.455, 0, 0.516, 0, 0, 0, 0, 0, 0, 0.124, 0, 0, 0, 0, 0, 0, 0, 0.447, 0, 0, 0, 0,
      0.508, 0, 0, 0.438, 0, 0, 0, 0, 0, 0, 0.515, 0, 0, 0.513, 0, 0.445, 0, 0, 0, 0.47, 0, 0, 0, 0,
      0.525, 0, 0, 0.506, 0, 0, 0, 0, 0, 0.463, 0, 0, 0, 0, 0, 0,
    ],
    normalizedActivation: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0.8940520446096654, 0, 0, 0, 0.9609665427509293, 0, 0, 0,
      0.9721189591078067, 0.8215613382899628, 0, 0, 0, 0.8159851301115241, 0, 0, 0, 0, 0, 0, 0,
      0.8364312267657992, 0, 0, 0, 0, 0.9739776951672863, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0.8215613382899628, 0, 0.966542750929368, 0, 0, 0.845724907063197, 0, 0, 0, 0,
      0.9275092936802973, 0, 0, 0, 0, 0.9646840148698884, 0, 0, 0.8345724907063197, 0, 0, 0, 0, 0,
      0, 0.8141263940520446, 0, 0, 0, 0, 0.9758364312267658, 0, 0, 0.9776951672862453, 0, 0, 0, 0,
      0.9460966542750929, 0, 0, 0.9739776951672863, 0.812267657992565, 0, 0, 0, 0, 0, 0,
      0.9275092936802973, 0, 0, 0.9442379182156133, 0, 0, 0.8921933085501857, 0, 0, 0, 0, 0, 0,
      0.9553903345724907, 0, 0.9405204460966542, 0.8178438661710037, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0.9721189591078067, 0, 0, 0, 0, 0, 0, 0, 0.9572490706319702, 0, 0, 0,
      0.9033457249070631, 0, 0, 0, 0.899628252788104, 0, 0.9684014869888475, 0, 0,
      0.8197026022304832, 0, 0.8048327137546468, 0, 0.9535315985130112, 0, 0, 0, 0.9591078066914498,
      0.9572490706319702, 0, 0, 0, 0.9609665427509293, 0, 0, 0.9628252788104089, 0,
      0.9646840148698884, 0, 0, 0.9795539033457249, 0, 0, 0, 0.9628252788104089, 0,
      0.9721189591078067, 0, 0, 0, 0, 0, 0, 0.8420074349442379, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0.845724907063197, 0, 0.9591078066914498, 0, 0, 0, 0, 0, 0, 0.23048327137546468, 0, 0,
      0, 0, 0, 0, 0, 0.8308550185873605, 0, 0, 0, 0, 0.9442379182156133, 0, 0, 0.8141263940520446,
      0, 0, 0, 0, 0, 0, 0.9572490706319702, 0, 0, 0.9535315985130112, 0, 0.8271375464684014, 0, 0,
      0, 0.8736059479553903, 0, 0, 0, 0, 0.9758364312267658, 0, 0, 0.9405204460966542, 0, 0, 0, 0,
      0, 0.8605947955390334, 0, 0, 0, 0, 0, 0,
    ],
    targetIdx: -1,
    absoluteTokenIdx: 529080,
    modelId: "baby",
  },
  {
    text: "ill me with thy sword,\nAnd not with such a cruel threatening look.\nSweet Clifford, hear me speak before I die.\nI am too mean a subject for thy wrath:\nBe thou revenged on men, and let me live.\n\nCLIFFORD:\nIn vain thou speak'st, poor boy; my father's blood\nHa",
    activations: [
      0, 0, 0, 0, 0, 0.521, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.479, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0.487, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.446, 0, 0, 0, 0, 0.52, 0, 0, 0, 0, 0, 0.506,
      0.426, 0, 0.516, 0, 0, 0, 0, 0, 0, 0.488, 0.503, 0, 0, 0, 0, 0, 0.519, 0.513, 0, 0, 0, 0, 0,
      0, 0, 0.497, 0, 0, 0, 0, 0, 0.521, 0.436, 0, 0, 0, 0.517, 0, 0, 0, 0.527, 0.449, 0, 0, 0,
      0.523, 0, 0.48, 0, 0.522, 0, 0, 0, 0, 0, 0.53, 0, 0, 0, 0, 0.461, 0, 0, 0, 0.49, 0.496, 0, 0,
      0.505, 0.443, 0, 0, 0.447, 0, 0, 0, 0, 0, 0.521, 0, 0, 0, 0, 0.486, 0, 0, 0, 0, 0, 0, 0, 0,
      0.441, 0, 0, 0, 0, 0, 0.521, 0, 0, 0, 0.486, 0, 0, 0, 0.517, 0, 0.518, 0, 0, 0.508, 0, 0,
      0.484, 0, 0, 0, 0.528, 0, 0, 0, 0.44, 0, 0, 0, 0, 0.521, 0, 0, 0, 0.538, 0, 0, 0, 0, 0.528, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.434, 0, 0, 0, 0, 0, 0.503, 0, 0, 0, 0,
      0.517, 0.438, 0, 0, 0, 0, 0, 0, 0, 0.487, 0.497, 0, 0, 0, 0.49, 0, 0, 0, 0, 0, 0, 0, 0.453, 0,
      0, 0.531, 0, 0, 0, 0, 0, 0, 0.458, 0.476, 0, 0, 0, 0.445,
    ],
    normalizedActivation: [
      0, 0, 0, 0, 0, 0.9684014869888475, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.8903345724907062, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0.9052044609665427, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0.828996282527881, 0, 0, 0, 0, 0.966542750929368, 0, 0, 0, 0, 0, 0.9405204460966542,
      0.7918215613382898, 0, 0.9591078066914498, 0, 0, 0, 0, 0, 0, 0.9070631970260222,
      0.9349442379182156, 0, 0, 0, 0, 0, 0.9646840148698884, 0.9535315985130112, 0, 0, 0, 0, 0, 0,
      0, 0.9237918215613382, 0, 0, 0, 0, 0, 0.9684014869888475, 0.8104089219330854, 0, 0, 0,
      0.9609665427509293, 0, 0, 0, 0.9795539033457249, 0.8345724907063197, 0, 0, 0,
      0.9721189591078067, 0, 0.8921933085501857, 0, 0.9702602230483272, 0, 0, 0, 0, 0,
      0.9851301115241635, 0, 0, 0, 0, 0.8568773234200744, 0, 0, 0, 0.9107806691449813,
      0.9219330855018587, 0, 0, 0.9386617100371747, 0.8234200743494423, 0, 0, 0.8308550185873605, 0,
      0, 0, 0, 0, 0.9684014869888475, 0, 0, 0, 0, 0.9033457249070631, 0, 0, 0, 0, 0, 0, 0, 0,
      0.8197026022304832, 0, 0, 0, 0, 0, 0.9684014869888475, 0, 0, 0, 0.9033457249070631, 0, 0, 0,
      0.9609665427509293, 0, 0.9628252788104089, 0, 0, 0.9442379182156133, 0, 0, 0.899628252788104,
      0, 0, 0, 0.9814126394052044, 0, 0, 0, 0.8178438661710037, 0, 0, 0, 0, 0.9684014869888475, 0,
      0, 0, 1, 0, 0, 0, 0, 0.9814126394052044, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0.8066914498141263, 0, 0, 0, 0, 0, 0.9349442379182156, 0, 0, 0, 0, 0.9609665427509293,
      0.8141263940520446, 0, 0, 0, 0, 0, 0, 0, 0.9052044609665427, 0.9237918215613382, 0, 0, 0,
      0.9107806691449813, 0, 0, 0, 0, 0, 0, 0, 0.8420074349442379, 0, 0, 0.9869888475836431, 0, 0,
      0, 0, 0, 0, 0.8513011152416357, 0.8847583643122675, 0, 0, 0, 0.8271375464684014,
    ],
    targetIdx: -1,
    absoluteTokenIdx: 593848,
    modelId: "baby",
  },
  {
    text: "e\nas Claudio's, to cross this in the smallest.\n\nDUKE VINCENTIO:\nBy the vow of mine order I warrant you, if my\ninstructions may be your guide. Let this Barnardine\nbe this morning executed, and his head born to Angelo.\n\nProvost:\nAngelo hath seen them both, a",
    activations: [
      0.518, 0, 0.447, 0, 0, 0, 0, 0.446, 0, 0, 0, 0.488, 0, 0, 0, 0, 0, 0.495, 0, 0, 0, 0.49, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.524, 0, 0, 0, 0.45, 0, 0, 0.522, 0, 0, 0, 0, 0, 0, 0, 0,
      0.138, 0, 0, 0, 0, 0, 0.132, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.519, 0, 0, 0.485, 0, 0, 0.499,
      0, 0, 0, 0, 0, 0.526, 0, 0.479, 0, 0, 0.524, 0, 0, 0, 0, 0, 0.447, 0, 0, 0.444, 0, 0, 0, 0,
      0.48, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.517, 0, 0, 0, 0, 0.445, 0, 0, 0,
      0.527, 0, 0, 0.492, 0, 0, 0, 0, 0, 0, 0, 0.526, 0, 0, 0, 0.513, 0, 0, 0, 0, 0, 0, 0, 0, 0.441,
      0, 0, 0.446, 0, 0, 0, 0, 0.524, 0, 0, 0.519, 0, 0, 0, 0, 0, 0, 0, 0.5, 0, 0, 0, 0, 0, 0, 0.51,
      0, 0.521, 0, 0, 0, 0.538, 0, 0, 0, 0.459, 0, 0, 0, 0, 0, 0, 0, 0, 0.526, 0.438, 0, 0, 0, 0.51,
      0, 0, 0, 0, 0.473, 0, 0, 0, 0, 0.519, 0, 0.491, 0, 0, 0, 0, 0, 0.475, 0, 0.485, 0, 0, 0, 0, 0,
      0, 0, 0.511, 0, 0.49, 0, 0, 0.44, 0, 0, 0, 0, 0.525, 0.538, 0, 0, 0, 0, 0.532, 0, 0, 0, 0.458,
      0, 0, 0, 0, 0.445,
    ],
    normalizedActivation: [
      0.9628252788104089, 0, 0.8308550185873605, 0, 0, 0, 0, 0.828996282527881, 0, 0, 0,
      0.9070631970260222, 0, 0, 0, 0, 0, 0.9200743494423791, 0, 0, 0, 0.9107806691449813, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.9739776951672863, 0, 0, 0, 0.8364312267657992, 0, 0,
      0.9702602230483272, 0, 0, 0, 0, 0, 0, 0, 0, 0.25650557620817843, 0, 0, 0, 0, 0,
      0.2453531598513011, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.9646840148698884, 0, 0,
      0.9014869888475836, 0, 0, 0.9275092936802973, 0, 0, 0, 0, 0, 0.9776951672862453, 0,
      0.8903345724907062, 0, 0, 0.9739776951672863, 0, 0, 0, 0, 0, 0.8308550185873605, 0, 0,
      0.8252788104089219, 0, 0, 0, 0, 0.8921933085501857, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0.9609665427509293, 0, 0, 0, 0, 0.8271375464684014, 0, 0, 0, 0.9795539033457249,
      0, 0, 0.9144981412639405, 0, 0, 0, 0, 0, 0, 0, 0.9776951672862453, 0, 0, 0,
      0.9535315985130112, 0, 0, 0, 0, 0, 0, 0, 0, 0.8197026022304832, 0, 0, 0.828996282527881, 0, 0,
      0, 0, 0.9739776951672863, 0, 0, 0.9646840148698884, 0, 0, 0, 0, 0, 0, 0, 0.929368029739777, 0,
      0, 0, 0, 0, 0, 0.9479553903345724, 0, 0.9684014869888475, 0, 0, 0, 1, 0, 0, 0,
      0.8531598513011153, 0, 0, 0, 0, 0, 0, 0, 0, 0.9776951672862453, 0.8141263940520446, 0, 0, 0,
      0.9479553903345724, 0, 0, 0, 0, 0.8791821561338289, 0, 0, 0, 0, 0.9646840148698884, 0,
      0.9126394052044609, 0, 0, 0, 0, 0, 0.882899628252788, 0, 0.9014869888475836, 0, 0, 0, 0, 0, 0,
      0, 0.949814126394052, 0, 0.9107806691449813, 0, 0, 0.8178438661710037, 0, 0, 0, 0,
      0.9758364312267658, 1, 0, 0, 0, 0, 0.9888475836431226, 0, 0, 0, 0.8513011152416357, 0, 0, 0,
      0, 0.8271375464684014,
    ],
    targetIdx: -1,
    absoluteTokenIdx: 929720,
    modelId: "baby",
  },
  {
    text: "\n\nGLOUCESTER:\nBut I know none, and therefore am no beast.\n\nLADY ANNE:\nO wonderful, when devils tell the truth!\n\nGLOUCESTER:\nMore wonderful, when angels are so angry.\nVouchsafe, divine perfection of a woman,\nOf these supposed-evils, to give me leave,\nBy cir",
    activations: [
      0, 0, 0, 0, 0, 0, 0, 0.133, 0, 0, 0.128, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.476, 0, 0, 0,
      0.475, 0, 0.52, 0, 0, 0.445, 0, 0, 0, 0, 0, 0.525, 0, 0.512, 0, 0.496, 0, 0.515, 0, 0.442, 0,
      0, 0, 0.476, 0, 0, 0.506, 0.426, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.131, 0, 0, 0, 0, 0,
      0.496, 0, 0, 0.519, 0, 0, 0, 0, 0, 0, 0, 0, 0.516, 0, 0, 0, 0.517, 0, 0, 0, 0, 0, 0, 0.513, 0,
      0, 0, 0, 0, 0.522, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.131, 0, 0, 0.142, 0, 0, 0, 0,
      0.491, 0, 0.532, 0, 0, 0.509, 0, 0, 0.523, 0, 0, 0, 0, 0, 0, 0, 0, 0.521, 0, 0, 0.441, 0, 0,
      0.522, 0, 0, 0, 0.441, 0, 0.515, 0, 0, 0.501, 0, 0.446, 0, 0, 0, 0, 0, 0, 0, 0.484, 0, 0, 0,
      0, 0.451, 0, 0.526, 0, 0, 0, 0, 0, 0, 0, 0.51, 0, 0, 0.511, 0, 0, 0.526, 0, 0, 0, 0.475, 0, 0,
      0.503, 0, 0, 0.438, 0, 0, 0.505, 0, 0.45, 0, 0, 0, 0, 0, 0, 0, 0, 0.519, 0, 0.518, 0, 0, 0, 0,
      0, 0.475, 0, 0.517, 0, 0, 0.537, 0, 0, 0, 0, 0, 0, 0, 0.487, 0, 0, 0, 0, 0.534, 0, 0, 0.538,
      0, 0, 0.521, 0.443, 0, 0.518, 0, 0, 0, 0, 0, 0, 0, 0,
    ],
    normalizedActivation: [
      0, 0, 0, 0, 0, 0, 0, 0.24721189591078066, 0, 0, 0.2379182156133829, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0.8847583643122675, 0, 0, 0, 0.882899628252788, 0, 0.966542750929368, 0, 0,
      0.8271375464684014, 0, 0, 0, 0, 0, 0.9758364312267658, 0, 0.9516728624535316, 0,
      0.9219330855018587, 0, 0.9572490706319702, 0, 0.8215613382899628, 0, 0, 0, 0.8847583643122675,
      0, 0, 0.9405204460966542, 0.7918215613382898, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0.24349442379182157, 0, 0, 0, 0, 0, 0.9219330855018587, 0, 0, 0.9646840148698884, 0, 0, 0, 0,
      0, 0, 0, 0, 0.9591078066914498, 0, 0, 0, 0.9609665427509293, 0, 0, 0, 0, 0, 0,
      0.9535315985130112, 0, 0, 0, 0, 0, 0.9702602230483272, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0.24349442379182157, 0, 0, 0.2639405204460966, 0, 0, 0, 0, 0.9126394052044609, 0,
      0.9888475836431226, 0, 0, 0.9460966542750929, 0, 0, 0.9721189591078067, 0, 0, 0, 0, 0, 0, 0,
      0, 0.9684014869888475, 0, 0, 0.8197026022304832, 0, 0, 0.9702602230483272, 0, 0, 0,
      0.8197026022304832, 0, 0.9572490706319702, 0, 0, 0.9312267657992565, 0, 0.828996282527881, 0,
      0, 0, 0, 0, 0, 0, 0.899628252788104, 0, 0, 0, 0, 0.8382899628252788, 0, 0.9776951672862453, 0,
      0, 0, 0, 0, 0, 0, 0.9479553903345724, 0, 0, 0.949814126394052, 0, 0, 0.9776951672862453, 0, 0,
      0, 0.882899628252788, 0, 0, 0.9349442379182156, 0, 0, 0.8141263940520446, 0, 0,
      0.9386617100371747, 0, 0.8364312267657992, 0, 0, 0, 0, 0, 0, 0, 0, 0.9646840148698884, 0,
      0.9628252788104089, 0, 0, 0, 0, 0, 0.882899628252788, 0, 0.9609665427509293, 0, 0,
      0.9981412639405205, 0, 0, 0, 0, 0, 0, 0, 0.9052044609665427, 0, 0, 0, 0, 0.9925650557620818,
      0, 0, 1, 0, 0, 0.9684014869888475, 0.8234200743494423, 0, 0.9628252788104089, 0, 0, 0, 0, 0,
      0, 0, 0,
    ],
    targetIdx: -1,
    absoluteTokenIdx: 165089,
    modelId: "baby",
  },
  {
    text: "PSON:\nTrue; and therefore women, being the weaker vessels,\nare ever thrust to the wall: therefore I will push\nMontague's men from the wall, and thrust his maids\nto the wall.\n\nGREGORY:\nThe quarrel is between our masters and us their men.\n\nSAMPSON:\n'Tis all ",
    activations: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0.512, 0, 0, 0.447, 0, 0, 0, 0, 0, 0.512, 0, 0.523, 0, 0.476, 0,
      0.521, 0, 0, 0.487, 0, 0.519, 0, 0, 0, 0, 0.522, 0, 0, 0, 0, 0, 0, 0.525, 0, 0, 0.528, 0.442,
      0, 0.52, 0, 0, 0, 0.524, 0, 0, 0.525, 0, 0, 0, 0, 0.457, 0, 0.519, 0, 0.529, 0, 0.523, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0.491, 0, 0, 0, 0.517, 0, 0, 0.446, 0, 0, 0, 0, 0, 0, 0.513, 0, 0.519,
      0, 0.499, 0, 0.513, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.491, 0, 0, 0.44, 0, 0, 0.518,
      0, 0, 0, 0, 0.529, 0, 0, 0, 0, 0.517, 0, 0, 0, 0, 0.529, 0, 0, 0.44, 0, 0, 0, 0, 0.445, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.447, 0, 0, 0, 0, 0, 0.485, 0, 0, 0, 0.527, 0, 0,
      0.443, 0, 0, 0, 0, 0, 0, 0, 0.11, 0, 0, 0, 0, 0, 0, 0, 0, 0.537, 0, 0, 0, 0.448, 0, 0, 0.525,
      0, 0, 0, 0, 0, 0, 0.51, 0, 0, 0.51, 0.527, 0, 0, 0.473, 0, 0, 0, 0, 0.445, 0, 0, 0.522, 0, 0,
      0, 0.438, 0, 0, 0, 0, 0, 0, 0, 0, 0.523, 0, 0, 0, 0, 0.516, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0.445, 0, 0, 0,
    ],
    normalizedActivation: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0.9516728624535316, 0, 0, 0.8308550185873605, 0, 0, 0, 0, 0,
      0.9516728624535316, 0, 0.9721189591078067, 0, 0.8847583643122675, 0, 0.9684014869888475, 0, 0,
      0.9052044609665427, 0, 0.9646840148698884, 0, 0, 0, 0, 0.9702602230483272, 0, 0, 0, 0, 0, 0,
      0.9758364312267658, 0, 0, 0.9814126394052044, 0.8215613382899628, 0, 0.966542750929368, 0, 0,
      0, 0.9739776951672863, 0, 0, 0.9758364312267658, 0, 0, 0, 0, 0.8494423791821561, 0,
      0.9646840148698884, 0, 0.983271375464684, 0, 0.9721189591078067, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0.9126394052044609, 0, 0, 0, 0.9609665427509293, 0, 0, 0.828996282527881, 0, 0, 0, 0, 0, 0,
      0.9535315985130112, 0, 0.9646840148698884, 0, 0.9275092936802973, 0, 0.9535315985130112, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.9126394052044609, 0, 0, 0.8178438661710037, 0, 0,
      0.9628252788104089, 0, 0, 0, 0, 0.983271375464684, 0, 0, 0, 0, 0.9609665427509293, 0, 0, 0, 0,
      0.983271375464684, 0, 0, 0.8178438661710037, 0, 0, 0, 0, 0.8271375464684014, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0.8308550185873605, 0, 0, 0, 0, 0, 0.9014869888475836, 0, 0, 0,
      0.9795539033457249, 0, 0, 0.8234200743494423, 0, 0, 0, 0, 0, 0, 0, 0.20446096654275092, 0, 0,
      0, 0, 0, 0, 0, 0, 0.9981412639405205, 0, 0, 0, 0.8327137546468402, 0, 0, 0.9758364312267658,
      0, 0, 0, 0, 0, 0, 0.9479553903345724, 0, 0, 0.9479553903345724, 0.9795539033457249, 0, 0,
      0.8791821561338289, 0, 0, 0, 0, 0.8271375464684014, 0, 0, 0.9702602230483272, 0, 0, 0,
      0.8141263940520446, 0, 0, 0, 0, 0, 0, 0, 0, 0.9721189591078067, 0, 0, 0, 0,
      0.9591078066914498, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.8271375464684014,
      0, 0, 0,
    ],
    targetIdx: -1,
    absoluteTokenIdx: 443834,
    modelId: "baby",
  },
];

export { Sample1079869 };
